import { render, staticRenderFns } from "./uploadAppendix.vue?vue&type=template&id=3c943ed6&scoped=true"
import script from "./uploadAppendix.vue?vue&type=script&lang=js"
export * from "./uploadAppendix.vue?vue&type=script&lang=js"
import style0 from "./uploadAppendix.vue?vue&type=style&index=0&id=3c943ed6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c943ed6",
  null
  
)

export default component.exports